import { useEffect, useState } from "react";
import { Comment } from "./Comment";
import { Box, Button, LinearProgress, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { MyListApi } from "../utils/restApi";
import { addNotification } from "../slices/notificationSlice";
import { NewComment } from "./NewComment";

const MAX_COMMENT_LENGTH = 256;
const MAX_NEW_LINES = 4;

export const ItemComments = ({ itemId, count, headingId }) => {

    const user = useSelector(state => state.login.user);
    const dispatch = useDispatch();

    const [comments, setComments] = useState([]);
    const [status, setStatus] = useState('idle');
    const [maxPageCount, setMaxPageCount] = useState(0);
    const [curPage, setCurPage] = useState(0);

    useEffect(() => {
        if (status === 'idle') {
            setStatus('fetching');
            MyListApi.getComments('ITEM', itemId, curPage)
                .then(data => {
                    setStatus('succeeded');
                    setMaxPageCount(data.maxPageCount);
                    setComments(comments.concat(data.items));
                })
                .catch(error => {
                    setStatus('error');
                    dispatch(addNotification({
                        message: error.message,
                        type: 'error',
                    }));
                });
        }
    }, [status, comments, curPage]);

    const handleLoadMore = () => {
        setCurPage(curPage + 1);
        setStatus('idle');
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Typography id={headingId} component="h2" variant="h3">
                Comments{typeof count === 'number' ? <Typography component="span" color="text.secondary" sx={{ fontWeight: 400 }}>{` · ${count}`}</Typography> : null}
            </Typography>
            {user ? <NewComment entityType='ITEM' entityId={itemId} /> : null}
            {comments.map(c => <Comment key={c.id} comment={c} />)}
            {status === 'succeeded' && comments.length === 0 ? <Typography variant="body2" color="text.secondary">No comments yet.</Typography> : null}
            {curPage + 1 < maxPageCount ? <Button variant="outlined" onClick={handleLoadMore} disabled={status === 'idle' || status === 'fetching'}>Load more</Button> : null}
            {status === 'idle' || status === 'fetching' ? <LinearProgress aria-label="Loading comments" /> : null}
        </Box>
    );
}